import { api } from "../common/http";

const TenantUsersApi = {
  list: async ({
    page = 0,
    size = 20,
    sort = "firstName,asc",
    q,
    role,
  } = {}) => {
    const params = { page, size, sort };
    if (q && q.trim()) params.q = q.trim();
    if (role && role !== "ALL") params.role = role;
    const res = await api.get("/tenant/users", { params });
    return res.data;
  },

  getById: async (id) => (await api.get(`/tenant/users/${id}`)).data,

  getByUuid: async (uuid) => (await api.get(`/tenant/users/uuid/${uuid}`)).data,

  update: async (id, dto) => (await api.put(`/tenant/users/${id}`, dto)).data,

  updateStatus: async (id, active) =>
    (await api.patch(`/tenant/users/${id}/status`, { active })).data,

  updateRoles: async (id, roles) =>
    (await api.put(`/tenant/users/${id}/roles`, { roles })).data,

  remove: async (id) => (await api.delete(`/tenant/users/${id}`)).data,
};

export default TenantUsersApi;
